import ReportsMenu from "./ReportsMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import WingsDropDown from "../Shared/WingsDropDown";
import StudentStatusDropDown from "../Shared/StudentStatusDropDown";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import csvDownload from "json-to-csv-export";

const today = () => moment().format(config.date_format_input);

const StatusWiseChange = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loaddata, setLoaddata] = useState(false);
  const [statusName, setStatusName] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [wingId, setWingId] = useState("");
  const [statusTypeId, setStatusTypeId] = useState("");
  const [reappear, setReappear] = useState(false);

  const [filters, setFilters] = useState(null);

  document.title = "Student Status Change Report";

  const buildRequest = (page, size) => {
    const w = parseInt(String(filters.wingId).trim(), 10);
    const statusId = parseInt(String(filters.statusTypeId).trim(), 10);
    return {
      AccessKey,
      UserID,
      MemberType,
      pageNo: page,
      pageSize: size,
      StartDate: filters.startDate,
      EndDate: filters.endDate,
      Wing_Id: Number.isFinite(w) ? w : 0,
      Status_Type_Id: statusId,
      Reappear: filters.reappear,
    };
  };

  useEffect(() => {
    if (!filters) {
      setLedger([]);
      setTotalRecords(0);
      setStatusName("");
      return;
    }

    const statusId = parseInt(String(filters.statusTypeId).trim(), 10);
    if (!Number.isFinite(statusId) || statusId <= 0) {
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Reports/GetStatusChangeList",
      headers: { "Content-Type": "application/json" },
      data: buildRequest(pageNo, pageSize),
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setStatusName(response.data.statusName || "");
        } else {
          setLedger([]);
          setTotalRecords(0);
          setStatusName("");
          toast.error(response.data.status_message || "Unable to load report.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setTotalRecords(0);
        setLoading(false);
        toast.error("Network error while loading report.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [filters, pageNo, pageSize]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }

    const sd = form.StartDate.value;
    const ed = form.EndDate.value;
    const statusVal = form.Status.value;
    const wingVal = form.Wing.value;

    if (!statusVal || parseInt(statusVal, 10) <= 0) {
      toast.error("Please select a status type.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setStartDate(sd);
    setEndDate(ed);
    setStatusTypeId(statusVal);
    setWingId(wingVal);
    setReappear(!!form.Reappear?.checked);
    setFilters({
      startDate: sd,
      endDate: ed,
      statusTypeId: statusVal,
      wingId: wingVal,
      reappear: !!form.Reappear?.checked,
    });
    setPageNo(1);
    setValidated(true);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const printUrl = filters
    ? `/Reports/StatusWisePrint?StartDate=${encodeURIComponent(filters.startDate)}&EndDate=${encodeURIComponent(filters.endDate)}&Wing_Id=${encodeURIComponent(filters.wingId || "")}&Status=${encodeURIComponent(filters.statusTypeId)}&Reappear=${filters.reappear ? "1" : "0"}`
    : "#";

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{item.Serial_No}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_Name}</td>
          <td>{item.Status_Type_Name}</td>
          <td>{item.Wing_Name}</td>
          <td>{item.Class_Name}</td>
          <td>{item.Section_Name}</td>
          <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
          <td>{item.Modified_By}</td>
          <td>{item.Remarks}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="10">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            {filters
              ? "No status changes found for the selected criteria."
              : "Select dates and status type, then click Search."}
          </h4>
        </td>
      </tr>
    );
  };

  const handleSubmitForCvs = () => {
    if (!filters) {
      toast.error("Run a search before exporting.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoaddata(true);
    axios({
      method: "post",
      url: config.base_url + "Reports/GetStatusChangeList",
      headers: { "Content-Type": "application/json" },
      data: buildRequest(1, 10000),
    })
      .then((response) => {
        if (response.data.status_code === 1 && response.data.totalRecords > 0) {
          const rows = response.data.ListofRecords.map((rest) => ({
            Serial_No: rest.Serial_No,
            Student_ID: rest.Student_ID,
            Reg_No: rest.Registration_No,
            Name: rest.Student_Name,
            Status: rest.Status_Type_Name,
            Date: moment(rest.Dated).format("DD/MM/YYYY"),
            Modified_By: rest.Modified_By,
            Wing: rest.Wing_Name,
            Class: rest.Class_Name,
            Section: rest.Section_Name,
            Remarks: rest.Remarks,
          }));
          csvDownload({
            data: rows,
            filename: "StudentStatusChange",
            delimiter: ",",
            headers: [
              "Serial_No",
              "Student_ID",
              "Reg_No",
              "Name",
              "Status",
              "Date",
              "Modified_By",
              "Wing",
              "Class",
              "Section",
              "Remarks",
            ],
          });
        } else if (response.data.status_code === 1) {
          toast.error("There is no data available for download.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoaddata(false);
      })
      .catch(() => {
        toast.error("Network error while exporting.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoaddata(false);
      });
  };

  return (
    <>
      <ReportsMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Reports/ReportsDashboard">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Status Change
                  </li>
                </ol>
              </nav>
              <div className="page-title">Student Status Change Report</div>
              {statusName && filters && (
                <p className="text-muted mb-0 small">
                  {statusName}
                  {filters.reappear ? " (reappear only)" : ""} —{" "}
                  {moment(filters.startDate).format("DD/MM/YYYY")} to{" "}
                  {moment(filters.endDate).format("DD/MM/YYYY")}
                  {totalRecords > 0 ? ` — ${totalRecords} record(s)` : ""}
                </p>
              )}
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <button
                  type="button"
                  onClick={() => setShowFilters((v) => !v)}
                  className="button button-white button-icon"
                >
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  <i className="ri-filter-3-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`collapse ${showFilters ? "show" : ""}`}>
        <div className="page-content">
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="container">
              <div className="card mb-2">
                <div className="card-body p-md-4">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Start Date:</label>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className="form-control"
                          required
                          name="StartDate"
                          max={today()}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>End Date:</label>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          className="form-control"
                          required
                          name="EndDate"
                          max={today()}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Wing:</label>
                        <select
                          name="Wing"
                          className="form-select"
                          value={wingId}
                          onChange={(e) => setWingId(e.target.value)}
                        >
                          <option value="">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Status Type:</label>
                        <select
                          name="Status"
                          value={statusTypeId}
                          onChange={(e) => setStatusTypeId(e.target.value)}
                          className="form-select"
                          required
                        >
                          <option value="">Please Select</option>
                          <StudentStatusDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-check mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="Reappear"
                          checked={reappear}
                          onChange={(e) => setReappear(e.target.checked)}
                          id="ReappearOnly"
                        />
                        <label className="form-check-label" htmlFor="ReappearOnly">
                          Reappear list only
                        </label>
                      </div>
                    </div>
                    {loaddata ? (
                      <div className="col-md-2 offset-md-4 text-center">
                        <Spinner animation="border" role="status" />
                      </div>
                    ) : (
                      <div className="col-md-2 offset-md-4 text-end">
                        <button
                          type="button"
                          onClick={handleSubmitForCvs}
                          className="print-icon btn btn-link p-0 mt-4"
                          title="Export Excel"
                          disabled={!filters}
                        >
                          <i className="ri-file-excel-2-line" />
                        </button>
                      </div>
                    )}
                    <div className="col-md-2 text-end">
                      <button
                        type="submit"
                        className="w-100 button button-primary mt-4"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Reg. No</th>
                    <th>Student Name</th>
                    <th>Status</th>
                    <th>Wing</th>
                    <th>Class</th>
                    <th>Section</th>
                    <th>Change Date</th>
                    <th>Modified By</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="10" className="text-center">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderLedger()
                  )}
                </tbody>
              </table>
              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <select
                          className="form-select"
                          style={{ width: "100px" }}
                          value={pageSize}
                          onChange={(e) => {
                            setPageNo(1);
                            setPageSize(parseInt(e.target.value, 10));
                          }}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                      </div>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card mt-2">
            <div className="card-body p-md-4 text-end">
              {filters ? (
                <Link
                  className="button button-primary"
                  to={printUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Print Report
                </Link>
              ) : (
                <button type="button" className="button button-primary" disabled>
                  Print Report
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusWiseChange;
